/* eslint-disable no-extra-boolean-cast */
import React, { useRef, useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import Select, { components, OptionProps } from 'react-select'
const DropDownControlForLocation = ({
    label,
    options,
    error,
    control,
    name,
    showLabel = true,
    getCountry = () => {},
    id
}) => {
    const { Option } = components

    const IconOption = (props) => {
        const { label, countryName } = props.data
        return (
            <Option {...props}>
                <div className="react-select-option">{countryName}</div>
            </Option>
        )
    }
    const validateString = (value) => {
        try {
            if (!!JSON.parse(value).name) {
                return JSON.parse(value).name
            } else {
                return label
            }
        } catch (error) {
            return value
        }
    }

    const refReactSelect = useRef(null)
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isFocused ? '#002a3a' : null,
                color: isFocused ? 'white' : 'black',
                ':active': {
                    backgroundColor: '#002a3a'
                }
            }
        }
    }
    return (
        <>
            {showLabel ? (
                <Form.Label className="lcontrol">{label}</Form.Label>
            ) : (
                ''
            )}
            <Controller
                control={control}
                name={name}
                render={({ field: { value, onChange, ref } }) => {
                 
                    return (
                        <>
                            <Select
                                value={
                                    !!value?.countryName && !!value?.countryId
                                        ? value
                                        : null
                                }
                                // backspaceRemovesValue={false}
                                // isClearable={false}
                                // isDisabled={id ? false : true}
                                styles={{
                                    indicatorSeparator: (base) => ({
                                        ...base,
                                        display: 'none'
                                    }),
                                    ...colourStyles
                                }}
                                // controlShouldRenderValue={false}
                                onChange={(e) => {
                                    onChange(e)
                                    getCountry(e?._id)
                                }}
                                maxMenuHeight={150}
                                // placeholder='Select Country'
                                getOptionLabel={(erty) => {
                                    return erty.countryName
                                }}
                                getOptionValue={(ert) => {
                                    return ert.countryName
                                }}
                                name="react-selectpreferredIndustry"
                                className="basic-multi-select "
                                classNamePrefix="select"
                                options={options}
                                components={{ Option: IconOption }}
                            />
                            {error && (
                                <span
                                    className="error-message"
                                    style={{ color: 'red' }}
                                >
                                    {error}
                                </span>
                            )}
                        </>
                    )
                }}
                onFocus={() => refReactSelect.current.focus()}
            />
        </>
    )
}

export default React.memo(DropDownControlForLocation)
